import Text from '@eversports/react-components/primitives/Text'
import TextField from '@eversports/react-components/primitives/TextField'
import React from 'react'

import { Localized } from '../../../localization/react'

const FiscalCode: React.FC<React.PropsWithChildren<unknown>> = () => (
  <>
    <Text>
      <Localized id="field-fiscal-code-disclaimer" />
    </Text>
    <TextField id="fiscalCode" name="fiscalCode" label={<Localized id="field-fiscal-code" />} fullWidth />
  </>
)

export default FiscalCode
